<template>
  <v-app>
    <v-content>
      <Toolbar app></Toolbar>
      <v-container fill-height fluid pa-0>
        <!-- This is to have the toolbar be transparent and properly positioned. It looks ugly. -->
        <router-view :key="$route.path"
          :style="$route.path !== '/register' &&
          $route.path !== `/register/${ $route.params.token }` &&
          $route.path !== '/login' &&
          $route.path !== `/login/${ $route.params.token }` &&
          $route.path !== `/reset-password/${ $route.params.token }` &&
          $route.path !== '/forgot-password' ? 'margin-top: -180px; padding-top: 180px !important;' : ''"
        />
      </v-container>
      <Footer app></Footer>
    </v-content>
  </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import Footer from '@/components/Footer'

export default {
  components: { Toolbar, Footer },
  watch: {
    '$route' (to, from) {
      this.$vuetify.goTo(0, { duration: '0', easing: 'linear' })
    }
  }
}
</script>

<style>
/* Overriding vuetify default styles
 Using !important is supposed to be a bad practice
 But apparently it's ok to use it to override values from external libraries
 More information: https://developer.mozilla.org/en-US/docs/Web/CSS/Specificity#The_!important_exception
 */

.spaced.display-3,
.spaced.display-2,
.spaced.display-1,
.spaced.subheading,
.spaced.headline,
.spaced.title {
  letter-spacing: 1px !important;
}

.oswald.display-3,
.oswald.display-2,
.oswald.display-1,
.oswald.subheading,
.oswald.headline,
.oswald.title {
  font-family: Oswald, sans-serif !important;
}

.monserrat.display-2,
.monserrat.display-1,
.monserrat.subheading,
.monserrat.body-2,
.monserrat.body-1,
.monserrat.caption {
  font-family: Monserrat, sans-serif !important;
}

.v-input__slot {
  padding: 4px !important;
}

.v-input__icon .v-icon {
  font-size: 20px;
  color: #29aafe;
  opacity: 0.50;
}

.v-input__prepend-inner {
  padding-right: 15px !important;
}

.v-label {
  color: #BDBDBD !important;
}

.box-shadow {
  -webkit-box-shadow: 0 5px 25px 0 rgba(0,0,0,.07);
  box-shadow: 0 5px 25px 0 rgba(0,0,0,.07);
}

.cursor-pointer {
  cursor: pointer;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .75s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.google-autocomplete-class {
  font-size: 14px;
  color: rgba(0,0,0,.77);
  width: 100%;
  height: 36px;
  border: 1px solid #e3e3e3;
  padding-left: 12px;
}
</style>
